var map = {
	"./404.png": 7486,
	"./about-2-bg.jpg": 3322,
	"./about-2.jpg": 7908,
	"./about.jpg": 8665,
	"./banner-poster.jpg": 9610,
	"./blog/bahria-8-10-marla.jpg": 1601,
	"./blog/commercial.jpeg": 8992,
	"./blog/commercial.jpg": 1687,
	"./blog/construction-1-scaled.jpg": 1301,
	"./blog/dha-4-1-kanal.jpeg": 3792,
	"./blog/dha-5-1-kanal-renovation.jpg": 3870,
	"./blog/dha-5-1-kanal.jpg": 6282,
	"./blog/interior.jpg": 6293,
	"./blog/mechanical.jpg": 4712,
	"./blog/project-management.jpg": 2156,
	"./blog/renovation.jpg": 5946,
	"./blog/residential.jpg": 8587,
	"./blog/warehosue-dhamyal.jpg": 6559,
	"./blog/why-us.jpg": 1734,
	"./brand-logo/01.png": 7235,
	"./brand-logo/02.png": 1480,
	"./brand-logo/03.png": 2609,
	"./brand-logo/04.png": 4894,
	"./brand-logo/05.png": 471,
	"./brand-logo/burgeon-logo.jpeg": 6963,
	"./brand-logo/burgeon-logo.png": 9394,
	"./demo-page/pages/about.jpg": 9218,
	"./demo-page/pages/blog-details-sidebar.jpg": 867,
	"./demo-page/pages/blog-details.jpg": 7284,
	"./demo-page/pages/blog-grid.jpg": 6152,
	"./demo-page/pages/blog-l-g.jpg": 8134,
	"./demo-page/pages/blog-l-l.jpg": 8409,
	"./demo-page/pages/blog-l-r.jpg": 3919,
	"./demo-page/pages/blog-r-g.jpg": 1260,
	"./demo-page/pages/contact.jpg": 929,
	"./demo-page/pages/home-1.jpg": 6410,
	"./demo-page/pages/home-2.jpg": 9013,
	"./demo-page/pages/service-details.jpg": 9041,
	"./demo-page/pages/service.jpg": 9352,
	"./demo-page/pages/team-details.jpg": 1023,
	"./demo-page/pages/team.jpg": 58,
	"./demo-page/react.svg": 1625,
	"./demo-page/support.png": 9493,
	"./favicon.ico": 7131,
	"./feature/01.png": 976,
	"./feature/02.png": 4475,
	"./feature/03.png": 3346,
	"./fun-fact-bg.jpg": 8920,
	"./icons/cancel-white.png": 9947,
	"./icons/cancel.png": 2043,
	"./icons/coloredbg.png": 5926,
	"./icons/loader.gif": 6203,
	"./icons/quote.png": 129,
	"./logo-dark.png": 3764,
	"./logo.png": 5549,
	"./organic-product/almond-field.jpg": 2810,
	"./organic-product/almond-oil.jpg": 3958,
	"./organic-product/apricot-oil-1.jpg": 4429,
	"./organic-product/apricot-oil.jpg": 9587,
	"./organic-product/jaggery-1.jpg": 9801,
	"./organic-product/jaggery.jpg": 7655,
	"./organic-product/shilajit.jpg": 2268,
	"./organic-product/walnut-oil.jpg": 7842,
	"./organic-product/wheat-starch.jpg": 9739,
	"./page-header.jpg": 7287,
	"./service/04.jpg": 9840,
	"./service/06.jpg": 1074,
	"./service/construction.jpeg": 7476,
	"./service/icon/analysis.png": 7654,
	"./service/icon/research.png": 4395,
	"./service/icon/strategy.png": 6787,
	"./service/icon/track-record.png": 425,
	"./service/organicfood.jpeg": 6186,
	"./service/service-bg.jpg": 9235,
	"./service/travel.jpeg": 5873,
	"./slider/01.jpg": 2065,
	"./technology/coursatic.png": 1538,
	"./technology/cream-soda.png": 8919,
	"./technology/dental-od.png": 243,
	"./technology/eCommerce.png": 3863,
	"./technology/go-parent.png": 1888,
	"./technology/human-resource.jpg": 7451,
	"./technology/idea.png": 3410,
	"./technology/lead-perfection.png": 6647,
	"./technology/mobile.jpg": 149,
	"./technology/palletpal.png": 4994,
	"./technology/projul.png": 9261,
	"./technology/simple-safety.png": 7182,
	"./technology/support-maintenance.jpg": 7540,
	"./technology/team-arrow.png": 4236,
	"./technology/team-bg-2.jpg": 4847,
	"./technology/team-bg.jpg": 5914,
	"./technology/team-details.jpg": 2981,
	"./technology/technology.jpg": 5413,
	"./technology/web.jpg": 4945,
	"./testimonial/bg-dot.png": 8463,
	"./testimonial/client-01.jpg": 2025,
	"./testimonial/client-02.jpg": 8318,
	"./testimonial/client-03.jpg": 9451,
	"./testimonial/h-2-t-01.png": 6130,
	"./testimonial/h-2-t-02.png": 4921,
	"./testimonial/h-2-t-03.png": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;